@use '../../scss/utility/functions' as utility;
@use './progress-vars';

:host {
  @include progress-vars.wb-progress-vars;

  /** @prop --size: The thickness of the progress indicator */
  --size: var(--progress-size);
  /** @prop --border-radius: The border radius of the progress indicator */
  --border-radius: var(--progress-radius);
  /** @prop --background-color: The background color of the progress indicator */
  --background-color: var(--progress-background-color);
  /** @prop --track-color: The track color of the progress indicator */
  --track-color: var(--progress-filled-color);

  display: block;
  background: var(--background-color);
  border-radius: var(--border-radius);
  overflow: hidden;

  .track {
    position: relative;
    background: var(--track-color);
  }

  @keyframes progressLoopHorizontalRtl {
    0% {
      transform: translate3d(0, 0, 0);
    }
    100% {
      transform: translate3d(-350%, 0, 0);
    }
  }

  @keyframes progressLoopHorizontal {
    0% {
      transform: translate3d(0, 0, 0);
    }
    100% {
      transform: translate3d(350%, 0, 0);
    }
  }

  @keyframes progressLoopVertical {
    0% {
      transform: translate3d(0, 0, 0);
    }
    100% {
      transform: translate3d(0, 350%, 0);
    }
  }
}

:host([compact]) {
  @include progress-vars.wb-progress-compact-vars;
}

:host([rounded]) {
  @include progress-vars.wb-progress-rounded-vars;
}

:host([direction='horizontal']) {
  width: 100%;
  height: var(--size);

  .track {
    height: var(--size);
    transition: width 1s var(--wb-move);
  }
}

:host([direction='horizontal'][value='indeterminate']) .track {
  position: relative;
  inset-inline-start: -50%;
  width: 50%;
  animation: progressLoopHorizontal 2s var(--wb-move) infinite;
}

:host([is-rtl][direction='horizontal'][value='indeterminate']) .track {
  animation-name: progressLoopHorizontalRtl;
}

:host([direction='vertical']) {
  width: var(--size);
  height: 100%;

  .track {
    transition: height 1s var(--wb-move);
  }
}

:host([direction='vertical'][value='indeterminate']) .track {
  inset-block-start: -50%;
  height: 50%;
  animation: progressLoopVertical 2s var(--wb-move) infinite;
}
